import { LogTimeRange } from "../../../../types/enums/campaign-enums";
import { StoreActionType as Type } from "../../types";

type LogFilterState = {
  timeRange: number;
  dateRange: {
    beginDate: string;
    endDate: string;
  };
};

const initialState: LogFilterState = {
  timeRange: LogTimeRange.Last5Minute,
  dateRange: {
    beginDate: "",
    endDate: "",
  },
};

export const logFilterReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.SET_CAMPAIGN_LOG_FILTER:
      return {
        ...state,
        timeRange: action.payload.timeRange,
        dateRange: action.payload.dateRange,
      } as LogFilterState;
    default:
      return state;
  }
};
